import React from 'react';
import { useCart } from '../../context/CartContext';

export function CartSidebar({ onCheckout }) {
  const { items, removeItem, updateQty, total, shipping, grandTotal, count, cartOpen, setCartOpen } = useCart();
  return (
    <>
      {cartOpen && <div className="cart-overlay" onClick={() => setCartOpen(false)} />}
      <div className={`cart-sidebar${cartOpen ? ' open' : ''}`}>
        <div className="cart-header">
          <h3 className="cart-title">
            Cart {count > 0 && <span className="cart-count-badge">{count}</span>}
          </h3>
          <button className="cart-close" onClick={() => setCartOpen(false)} aria-label="Close cart">✕</button>
        </div>
        {items.length === 0 ? (
          <div className="cart-empty">
            <div className="cart-empty-icon">🛒</div>
            <p>Your cart is empty</p>
            <button className="btn-primary btn-sm" onClick={() => setCartOpen(false)}>Browse Products</button>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {items.map(item => (
                <div className="cart-item" key={item.id}>
                  <img src={item.image} alt={item.name} className="cart-item-img" />
                  <div className="cart-item-info">
                    <p className="cart-item-name">{item.name}</p>
                    <p className="cart-item-price">₹{item.price}</p>
                  </div>
                  <div className="cart-item-qty">
                    <button onClick={() => updateQty(item.id, item.qty - 1)}>−</button>
                    <span>{item.qty}</span>
                    <button onClick={() => updateQty(item.id, item.qty + 1)}>+</button>
                  </div>
                  <button className="cart-item-remove" onClick={() => removeItem(item.id)} aria-label="Remove item">✕</button>
                </div>
              ))}
            </div>
            <div className="cart-footer">
              <div className="cart-total-row">
                <span>Subtotal</span>
                <span>₹{total}</span>
              </div>
              <div className="cart-total-row cart-shipping-row">
                <span>Shipping</span>
                {shipping === 0
                  ? <span><s className="cart-shipping-strike">₹75</s> <span className="cart-shipping-free">FREE</span></span>
                  : <span>₹75</span>
                }
              </div>
              {shipping > 0 && (
                <p className="cart-free-shipping-hint">Add ₹{299 - total} more for FREE shipping!</p>
              )}
              <div className="cart-total-row cart-grand-total-row">
                <strong>Total</strong>
                <strong>₹{grandTotal}</strong>
              </div>
              <button className="btn-primary btn-cart cart-checkout-btn" onClick={onCheckout}>
                Proceed to Checkout →
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}
